import RubricSettings from './RubricSettings'
export default RubricSettings
